import {main} from './app.js';
import {locales} from './i18n.js';
import {dynamicImport} from './utils.js';

let lang = document.documentElement.lang;
let locale = lang.replace('-', '_');
Promise.all([
  dynamicImport(`../locales/${locale}/messages.json`, {with: {type: 'json'}}).then((d) => {
    locales[locale] = d.default;
  }),
  new Promise((r) => {
    return document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', r) : queueMicrotask(r);
  })
]).then(main);
